<div class="ea-panel ea-card-Swiper no-bg-m animated fadeIn relative">
  <h3 class="fs-16 semi-bold mbxl hidden-xs">Vos Opérations </h3>
  <ea-radio-header class="ea-panel-title-right" [choices]="[
      ['En cours', 'running'],
      ['Terminée', 'over'],
      ['En attente', 'pending'],
    ]">
  </ea-radio-header>
  <div class="ea-table-card-container">
    <div class="ea-table-card-row-container ea-table-card-headings">
      <th>
        <span class="ea-table-card-cell text-ellipsis">NOM DU PRODUIT</span>
      </th>
      <th><span class="ea-table-card-cell text-ellipsis">TYPE</span></th>
      <th>
        <span class="ea-table-card-cell text-ellipsis">GESTIONNAIRE </span>
      </th>
      <th>
        <span class="ea-table-card-cell text-ellipsis">DATE D’ACHAT</span>
      </th>
      <th><span class="ea-table-card-cell text-ellipsis">STATUS</span></th>
    </div>
    <div class="ea-table-card-statistics-body">
      <div [prCarousel] [maxWidth]="768">
        <div class="prCarouselContainer">
          <div>
            <div class="ea-table-card-row">
              <div class="ea-table-card-row-container scaleIn pointer">
                <div class="ea-table-card-cell text-ellipsis" data-label="Date">
                  <i
                    class="fa fa-pencil text-primary visible-sm-inline-block visible-md-inline-block visible-lg-inline-block"></i>
                  16/07/1993
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Nom">
                  Label
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Prix part">
                  10
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Nb de parts ">
                  0
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Type détention">
                  Test
                </div>
                <!-- <div>
                  <div>
                    <button class="btn ea-primary-filled m-auto visible-xs"><span>Modifier</span></button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div>
            <div class="ea-table-card-row">
              <div class="ea-table-card-row-container scaleIn pointer">
                <div class="ea-table-card-cell text-ellipsis" data-label="Date">
                  <i
                    class="fa fa-pencil text-primary visible-sm-inline-block visible-md-inline-block visible-lg-inline-block"></i>
                  16/07/1993
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Nom">
                  Label
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Prix part">
                  10
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Nb de parts ">
                  0
                </div>
                <div class="ea-table-card-cell text-ellipsis" data-label="Type détention">
                  Test
                </div>
                <!-- <div>
                  <div>
                    <button class="btn ea-primary-filled m-auto visible-xs"><span>Modifier</span></button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>